import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { isArray } from "util";

const getStatus = status => {
  switch (status) {
    case "C":
      return "Complete";
    case "P":
      return "Partial";
    case "Z":
      return "Void";
    default:
      return status;
  }
};

const getClear = clear => {
  switch (clear) {
    case "N":
      return "Not clear";
    case "Z":
      return "Not applicable";
    case "P":
      return "Provisional";
    case "I":
      return "Could not be scored";
    default:
      return "Clear / Passed";
  }
};

const getServiceStatus = status => {
  switch (status) {
    case "C":
      return "Closed";
    case "O":
      return "Open";
    case "V":
      return "Voided";
    default:
      return status;
  }
};

const getCriminalReportDetail = props => {
  const rows = [];
  const crimReport = _.get(props.data, "crimReport");
  if (props.data && crimReport) {
    const requests = _.get(crimReport, "request[0]");
    if (requests) {
      _.forEach(requests, (request, index) => {
        if (isArray(request)) {
          rows.push(
            <Table.Row key={`crim_req_${index}`}>
              <Table.Cell>{_.get(request, "[0].$.display", "")}</Table.Cell>
              <Table.Cell>{_.get(request, "[0]._", "")}</Table.Cell>
            </Table.Row>
          );
        }
      });
      rows.push(
        <Table.Row key={`crim_req_attr`}>
          <Table.Cell>Request number</Table.Cell>
          <Table.Cell>
            {_.get(crimReport, "criminalTree[0].$.request", "")}
          </Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`crim_req_cust`}>
          <Table.Cell>Customer</Table.Cell>
          <Table.Cell>
            {_.get(crimReport, "criminalTree[0].subjaCustomer[0]", "")}
          </Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`crim_req_stat`}>
          <Table.Cell>Status</Table.Cell>
          <Table.Cell>
            {getStatus(_.get(crimReport, "criminalTree[0].subjaStatus[0]", ""))}
          </Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`crim_req_req`}>
          <Table.Cell>Requestor</Table.Cell>
          <Table.Cell>
            {_.get(crimReport, "criminalTree[0].subjaRequestor[0]", "")}
          </Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`crim_req_sub`}>
          <Table.Cell>Subscriber</Table.Cell>
          <Table.Cell>
            {_.get(crimReport, "criminalTree[0].subjaSubscriber[0]", "")}
          </Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`crim_req_ent`}>
          <Table.Cell>Entered on</Table.Cell>
          <Table.Cell>
            {_.get(crimReport, "criminalTree[0].subjaEntered[0]", "")}
          </Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`crim_req_com`}>
          <Table.Cell>Completed on</Table.Cell>
          <Table.Cell>
            {_.get(crimReport, "criminalTree[0].subjaClosed[0]", "")}
          </Table.Cell>
        </Table.Row>
      );
      const serviceResults = _.get(crimReport, "criminalTree[0].serviceResult");
      if (serviceResults) {
        _.forEach(serviceResults, (serviceResult, index) => {
          rows.push(
            <Table.Row key={`crim_req_cle_${index}`}>
              <Table.Cell>Clear</Table.Cell>
              <Table.Cell>
                {getClear(_.get(serviceResult, "$.clear", ""))}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`crim_req_ser_stat_${index}`}>
              <Table.Cell>Status</Table.Cell>
              <Table.Cell>
                {getServiceStatus(_.get(serviceResult, "$.status", ""))}
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`crim_req_ser_item_${index}`}>
              <Table.Cell>Item</Table.Cell>
              <Table.Cell>{_.get(serviceResult, "$.item", "")}</Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`crim_req_ser_county_${index}`}>
              <Table.Cell>County</Table.Cell>
              <Table.Cell>{_.get(serviceResult, "$.county", "")}</Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`crim_req_ser_state_${index}`}>
              <Table.Cell>State</Table.Cell>
              <Table.Cell>{_.get(serviceResult, "$.state", "")}</Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`crim_req_ser_code_${index}`}>
              <Table.Cell>Code</Table.Cell>
              <Table.Cell>{_.get(serviceResult, "$.code", "")}</Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`crim_req_ser_support_${index}`}>
              <Table.Cell>Support</Table.Cell>
              <Table.Cell>{_.get(serviceResult, "$.support", "")}</Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`crim_req_ser_name_${index}`}>
              <Table.Cell>Name</Table.Cell>
              <Table.Cell>{_.get(serviceResult, "$.name", "")}</Table.Cell>
            </Table.Row>
          );
          rows.push(
            <Table.Row key={`crim_req_ser_name_${index}`}>
              <Table.Cell colSpan={2}>
                <pre>{_.get(serviceResult, "_", "")}</pre>
              </Table.Cell>
            </Table.Row>
          );
        });
      }
    }
  }
  return (
    <Table>
      <Table.Body>{rows}</Table.Body>
    </Table>
  );
};

export default getCriminalReportDetail;



// WEBPACK FOOTER //
// ./src/components/myaccount/CriminalReportDetail.js